import queryString from 'query-string';
import getSPI from './SPI';
const demandServicePath = '/internal/demand/app-recommendations';
const RECOMMENDED_APPS_LIMIT = 3;
export function getAppRecommendations(cloudId, product) {
  const recommendationsUrl = "".concat(demandServicePath, "?").concat(queryString.stringify({
    cloudId,
    product,
    limit: RECOMMENDED_APPS_LIMIT
  }));
  return getSPI().fetchOk(recommendationsUrl, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  }).catch(error => {
    console.error('Failed to fetch app recommendations due to', error);
    return {
      appRecommendations: []
    };
  });
}